export const VUE_APP_BASEURL = "https://portal.sigmafarmersmarket.com/api/";
export const VUE_WEB_BASEURL = "https://portal.sigmafarmersmarket.com/";

// export const VUE_APP_BASEURL = "https://sigmaadmin.agtindia.co.in/api/";
// export const VUE_WEB_BASEURL = "https://sigmaadmin.agtindia.co.in/";

// export const VUE_APP_BASEURL = "http://127.0.0.1:8000/api/";
// export const VUE_WEB_BASEURL = "http://127.0.0.1:8000/";